import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common';

@Injectable()
export class NotificationProvider {

  constructor(public http: HttpClient, private commonService: CommonProvider) {}

  private _url: string = `${this.commonService.apiUrl}api/v1/notification`;
  
  getAll(): Observable<Response<Notification[]>> {
    return this.http.get<Response<Notification[]>>(this._url + '/list');
  }

}

export interface Notification {
  id: string;
  company_id?: string;
  User?: any;
  post_id?: string;
  club_id?: string;
  user_id?: string;
  type?: number;
  customData?: string;
  textContent?: string;
  createdAt?: string;
}




// WEBPACK FOOTER //
// ./src/providers/notification/notification.ts